import React, { useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/styles";

import gradients from "utils/gradients";

import useRouter from "utils/useRouter";
import axios from "utils/axios";
import Cookies from "js-cookie";
import crypto from "crypto-js";
import { AppContext } from "../../App";
import { jwtDecode } from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(6, 2),
  },
  card: {
    width: theme.breakpoints.values.md,
    maxWidth: "100%",
    overflow: "unset",
    display: "flex",
    position: "relative",
    "& > *": {
      flexGrow: 1,
      flexBasis: "50%",
      width: "50%",
    },
  },
  content: {
    padding: theme.spacing(8, 4, 3, 4),
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  icon: {
    backgroundImage: gradients.green,
    color: theme.palette.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: "absolute",
    top: -32,
    left: theme.spacing(3),
    height: 64,
    width: 64,
    fontSize: 32,
  },
  loginForm: {
    marginTop: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  person: {
    marginTop: theme.spacing(2),
    display: "flex",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
}));

const LoginOidc = async (props) => {
  const classes = useStyles();
  const router = useRouter();

  let oidcUser = localStorage.getItem("oidcUser");

  let formatedOutput = JSON.parse(oidcUser);

  let email = formatedOutput.profile["email"];

  let acct = formatedOutput.profile["acct"];
  let access = formatedOutput.profile["access"];
  let role = formatedOutput.profile["role"];
  if (typeof role === "string") {
    role = [role];
  }

  let name = formatedOutput.profile["name"];

  const getCustomerBasedOnAcct = async () => {
    let axios_path_to =
      process.env.REACT_APP_BACK_END_SERVER_URL +
      "/server/v1/customers/findCustomerBasedOnAcct";
    let payload = {
      acct: acct,
    };
    let response = await axios.post(axios_path_to, payload);
    return response.data;
  };
  const updateIntercom = (data) => {
    let hash = crypto.HmacSHA256(
      data.user_id,
      process.env.REACT_APP_INTERCOM_WEB_IDENTITY_SECRET_KEY
    );

    let hashInHex = crypto.enc.Hex.stringify(hash);

    window.Intercom("boot", {
      app_id: "p43ayu3j",
      name: data.name, // Full name
      email: data.email, // Email address
      user_id: data.user_id,
      organization_name: data.organization_name,
      user_hash: hashInHex,
    });
  };
  const processInercom = (customer) => {
    if (role.includes("Admin")) {
      let tempSuperUserData = {
        name: name,
        email: email,
        user_id: email,
        organization_name: "super user",
      };
      updateIntercom(tempSuperUserData);
      Cookies.set("customer_email", email);

      router.history.push("/all-customers");
      window.location.reload();
    } else {
      let tempData = {
        name: name, // Full name
        email: email, // Email address
        user_id: email,
        organization_name: customer.name,
      };
      updateIntercom(tempData);
      window.clarity("set", "customerName", customer.name);
      window.clarity("set", "customerEmail", email);
      Cookies.set("customer_id", customer && customer._id);
      Cookies.set("customer_name", customer && customer.name);
      Cookies.set("customer_slug", customer && customer.slug);
      Cookies.set("customer_email", email);
      Cookies.set(
        "self_serve_ads",
        customer &&
          customer.subscription &&
          customer.subscription.self_serve_ads &&
          customer.subscription.self_serve_ads.enable
          ? "true"
          : "false"
      );
      Cookies.set(
        "self_serve_emails",
        customer &&
          customer.subscription &&
          customer.subscription.self_serve_emails &&
          customer.subscription.self_serve_emails.enable
          ? "true"
          : "false"
      );
      Cookies.set(
        "connected_to_stripe",
        customer &&
          customer.subscription &&
          customer.subscription.stripe &&
          customer.subscription.stripe.connected_account_id != ""
          ? true
          : false
      );
      Cookies.set(
        "enable_winners_portal",
        typeof customer && customer.enable_winners_portal == "undefined"
          ? true
          : customer && customer.enable_winners_portal
      );
      window.location.href = window.location.origin + "/forward-correct-path";
    }
  };
  const assignOtherCookiesAndIntercomData = async () => {
    Cookies.set("show_org_nav", true);
    let customer = await getCustomerBasedOnAcct();

    Cookies.set("customer_id", customer && customer._id);
    Cookies.set("customer_name", customer && customer.name);
    Cookies.set("logged_in_user_name", name);
    processInercom(customer);
  };
  const assignRoles = () => {
    if (role.includes("Admin")) {
      Cookies.set("super_admin", "true");
      Cookies.set("bestofuserlevel", 5);
      Cookies.set("bestofphotouserlevel", 5);
    } else if (role.includes("Manager")) {
      Cookies.set("super_admin", "false");
      Cookies.set("member_role", "owner");
    } else if (role.includes("Agent-BestOf")) {
      Cookies.set("super_admin", "false");
      Cookies.set("member_role", "accountExecutive");
    } else if (role.includes("Ad-Rep")) {
      Cookies.set("super_admin", "false");
      Cookies.set("member_role", "adRep");
    }
  };
  const checkIsAllowedToBestOf = async () => {
    const allowedRoles = ["Admin", "Manager", "Agent-BestOf", "Ad-Rep"];

    const hasAllowedRole = role.some((r) => allowedRoles.includes(r));

    if (!hasAllowedRole) {
      console.error("Invalid role:", role);
      router.history.push("/error-privilages/");
      window.location.reload();
    }
  };

  const assignEverythingElse = async () => {
    Cookies.set("bestofuseracct", acct);

    await checkIsAllowedToBestOf();
    assignRoles();

    await assignOtherCookiesAndIntercomData();
  };
  await assignEverythingElse();

  return <div />;
};

export default LoginOidc;
